import { competerData } from './shared/state';

export default {
  namespaced: true,
  modules: {
    competerData
  }
};
